import { render, staticRenderFns } from "./CrosswordInstruction.vue?vue&type=template&id=469943a9"
import script from "./CrosswordInstruction.vue?vue&type=script&lang=js"
export * from "./CrosswordInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports